<template>
  <div class="mt-3">
    <template v-if="erpCamposIntegracao">
      <px-campos-integracao type="compra-item"
                            dense
                            :form-data="produto.cadastrosAdicionais"/>
    </template>
    <v-row dense class="mt-3">
      <v-col cols="12" md="6">
        <px-autocomplete-centro-custo
          dense
          :class="`rounded-tag-small ${isCentroCustoRequired ? 'required' : ''}`"
          :error="$v.produto.centroCusto.$error"
          @blur="$v.produto.centroCusto.$touch()"
          v-model="produto.centroCusto"/>
      </v-col>
      <v-col cols="12" md="6">
        <px-autocomplete-projeto
          dense
          class="rounded-tag-small"
          v-model="produto.projeto"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="6">
        <v-textarea
          outlined
          auto-grow
          label="Especificação"
          counter="1500"
          rows="3"
          class="rounded-tag-small"
          v-model="produto.especificacaoProduto"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-textarea
          outlined
          auto-grow
          label="Observações externas"
          counter="1500"
          rows="3"
          class="rounded-tag-small"
          v-model="produto.observacaoExterna"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6"
             v-if="produto.arquivosComprador && produto.arquivosComprador.length">
        <span class="caption font-weight-bold">Arquivos cotados</span>
        <px-anexo-chip :files="produto.arquivosComprador"
                       download-base-path="files/download-comprador"/>
      </v-col>
      <v-col cols="12" sm="6"
             v-if="produto.arquivosFornecedor && produto.arquivosFornecedor.length">
        <span class="caption font-weight-bold">Arquivos do fornecedor</span>
        <px-anexo-chip :files="produto.arquivosFornecedor"
                       download-base-path="files/download-fornecedor"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';
import {
  isFieldRequiredEntityItens,
} from '@/modules/erp-campos-obrigatorios/erp-campos-obrigatorios-utils';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    produto: {
      type: Object,
      required: true,
    },
    erpCamposIntegracao: {
      type: String,
    },
    camposObrigatorios: Object,
  },
  computed: {
    isCentroCustoRequired() {
      return isFieldRequiredEntityItens('centroCusto', this.camposObrigatorios);
    },
  },
  methods: {
    validate() {
      const isInvalid = this.validateForm();
      if (isInvalid) {
        this.$emit('invalid');
      }
      return isInvalid;
    },
  },
  validations: {
    produto: {
      centroCusto: {
        required: requiredIf(function () {
          return this.isCentroCustoRequired;
        }),
      },
    },
  },
};
</script>
